import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinSubscriptionEditRoute: InvariantJiraRoute = {
	name: 'legacy-gin-subscription-edit',
	path: '(/secure/|/)EditSubscription([!%]?[\\w]*).jspa',
};
